import { Link } from 'react-router-dom';
import '../styles/Resume.css';

export default function Resume() {

  const resumeData = {
    // ── PERSONAL INFORMATION ──────────────────────────────
    name: "Dylan Jeremy Malipol",
    title: "Computer Engineering Student",
    email: "dylanjeremymalipol@gmail.com",
    phone: "+63 908 525 9425",
    location: "Philippines",

    // ── OBJECTIVE ─────────────────────────────────────────
    objective: `Motivated Computer Engineering student seeking an opportunity to apply
     knowledge in software development, hardware systems, and problem-solving in a 
     dynamic organization while gaining hands-on industry experience.`,

    // ── EDUCATION ─────────────────────────────────────────
    education: [
      {
        degree: "Elementary",
        school: "The Golden Child Literacy Place",
        year: "2011 – 2017",
      },
      {
        degree: "Junior High School",
        school: "Greenville Academy of Sta. Clara",
        year: "2017 – 2020",
      },
      {
        degree: "Senior High School – STEM Strand",
        school: "Greenville Academy of Sta. Clara",
        year: "2020 – 2022",
        honors: "With Honors",
      },
    ],

    // ── SKILLS ────────────────────────────────────────────
    skills: {
      "Programming Languages": ["C++", "Python", "JavaScript"],
      "Web Development":       ["HTML", "CSS", "React", "Node.js"],
      "Tools & Technologies":  ["GitHub", "VS Code", "Arduino"],
      "Other Skills":          ["Embedded Systems", "Problem Solving", "Teamwork"],
    },

    // ── PROJECTS ──────────────────────────────────────────
    projects: [
      {
        title: "Number Base System Converter",
        tech: "C, VS Code",
        description: `Designed and implemented a number system converter with efficient decimal and octal algorithms, 
        improving usability and understanding of computer-based number systems.`,
      },
      {
        title: `Automated Hard Hat Detection System for
        Enhanced Safety in Construction`,
        tech: "Python, VS Code, OpenCV, Pytorch",
        description: `Designed and implemented a number system converter with efficient decimal and octal algorithms, 
        improving usability and understanding of computer-based number systems.`,
      },
      {
        title: "Portfolio Website",
        tech: "React, CSS, VS Code",
        description: "A personal portfolio website showcasing my projects, skills, and achievements built with React.",
      },
    ],

    // ── ACHIEVEMENTS ──────────────────────────────────────
    achievements: [
      "Ad Astra Scholar",
    ],

    // ── SEMINARS / TRAININGS ──────────────────────────────
    seminars: [
      {
        title: "Building a Sustainable Future: Empowering Communities through HIV Awareness and Education",
        organizer: "FAITH Colleges",
        date: "December 2024",
      },
      {
        title: "Engineering the Future: Career Stories and Industry Insights",
        organizer: "FAITH Colleges",
        date: "March 2025",
      },
      {
        title: `Connect. Innovate. Design. Revolutionize. Strengthening the Philippines' 
        Microelectronics Ecosystem through Strategic Collaboration and Talent Development`,
        organizer: "Center for Integrated Circuit and Device Research",
        date: "August 2025",
      },
      {
        title: `Arduino Workshop Part 1: Arduino Coding Skills Preparation for Hardware`,
        organizer: "FAITH Computer Engineering Society",
        date: "September 2025",
      },
      {
        title: `Arduino Workshop Part 2: Arduino Coding Skills Preparation for Hardware`,
        organizer: "FAITH Computer Engineering Society",
        date: "September 2025",
      },
      {
        title: `Design of RISC-V Microprocessors`,
        organizer: "FAITH Colleges",
        date: "November 2025",
      },
      {
        title: `Building Intelligence: Where Computer Engineering Meets Data Science`,
        organizer: "FAITH Colleges",
        date: "November 2025",
      },
    ],
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="resume-root">
      <div className="resume-bg" style={{ backgroundImage: `url('/bg.png')` }} />

      {/* ── Top bar (hidden on print) ── */}
      <nav className="resume-topbar no-print">
        <Link to="/" className="resume-logo">D.Malipol</Link>
        <div className="resume-topbar-actions">
          <Link to="/" className="resume-back">← Back to Home</Link>
          <button className="btn btn-primary" onClick={handlePrint}>
            🖨️ Print / Save PDF
          </button>
        </div>
      </nav>

      {/* ── Page wrapper ── */}
      <div className="resume-page-wrapper">

        {/* ── Screen header (hidden on print) ── */}
        <div className="resume-screen-header no-print">
          <p className="resume-section-label">◆ Resume</p>
          <h1 className="resume-page-title">My <span className="accent">Resume</span></h1>
          <p className="resume-page-subtitle">
            View below or click <strong>Print / Save PDF</strong> to download a formatted copy.
          </p>
        </div>

        {/* ══════════════════════════════════════════
            PRINTABLE RESUME DOCUMENT
        ══════════════════════════════════════════ */}
        <div className="resume-document">

          {/* ── LEFT SIDEBAR ── */}
          <div className="rdoc-left">

            {/* Photo */}
            <div className="rdoc-photo-wrap">
              <img src="/1000062748.jpeg" alt="Dylan Jeremy Malipol" />
            </div>

            {/* Name block */}
            <div className="rdoc-name-block">
              <h1 className="rdoc-name">{resumeData.name}</h1>
              <p className="rdoc-title">{resumeData.title}</p>
            </div>

            {/* Contact */}
            <div className="rdoc-sidebar-section">
              <h2 className="rdoc-sidebar-title">Contact</h2>
              <div className="rdoc-sidebar-divider" />
              <div className="rdoc-contact-list">
                <div className="rdoc-contact-item">
                  <span className="rdoc-contact-icon">✉</span>
                  <span>{resumeData.email}</span>
                </div>
                <div className="rdoc-contact-item">
                  <span className="rdoc-contact-icon">📞</span>
                  <span>{resumeData.phone}</span>
                </div>
                <div className="rdoc-contact-item">
                  <span className="rdoc-contact-icon">📍</span>
                  <span>{resumeData.location}</span>
                </div>
              </div>
            </div>

            {/* Skills */}
            <div className="rdoc-sidebar-section">
              <h2 className="rdoc-sidebar-title">Skills</h2>
              <div className="rdoc-sidebar-divider" />
              {Object.entries(resumeData.skills).map(([category, items]) => (
                <div key={category} className="rdoc-sidebar-skill-group">
                  <p className="rdoc-sidebar-skill-category">{category}</p>
                  <ul className="rdoc-sidebar-skill-list">
                    {items.map((skill, i) => (
                      <li key={i}>{skill}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

          </div>

          {/* ── RIGHT MAIN CONTENT ── */}
          <div className="rdoc-right">

            {/* Objective */}
            <div className="rdoc-section">
              <h2 className="rdoc-section-title">Objective</h2>
              <div className="rdoc-divider" />
              <p className="rdoc-objective">{resumeData.objective}</p>
            </div>

            {/* Education */}
            <div className="rdoc-section">
              <h2 className="rdoc-section-title">Education</h2>
              <div className="rdoc-divider" />
              {resumeData.education.map((edu, i) => (
                <div className="rdoc-entry" key={i}>
                  <div className="rdoc-entry-header">
                    <div>
                      <p className="rdoc-entry-title">{edu.degree}</p>
                      <p className="rdoc-entry-sub">{edu.school}</p>
                    </div>
                    <div className="rdoc-entry-right">
                      <span className="rdoc-year">{edu.year}</span>
                      {edu.honors && <span className="rdoc-badge">{edu.honors}</span>}
                    </div>
                  </div>
                  {edu.gwa && <p className="rdoc-entry-detail">GWA: {edu.gwa}</p>}
                </div>
              ))}
            </div>

            {/* Projects */}
            <div className="rdoc-section">
              <h2 className="rdoc-section-title">Projects</h2>
              <div className="rdoc-divider" />
              {resumeData.projects.map((project, i) => (
              <div className="rdoc-entry" key={i}>
                <div className="rdoc-entry-header">
                  <p className="rdoc-entry-title">{project.title}</p>
                  <span className="rdoc-tech">{project.tech}</span>
                </div>
              </div>
            ))}
            </div>

            {/* Achievements */}
            <div className="rdoc-section">
              <h2 className="rdoc-section-title">Achievements</h2>
              <div className="rdoc-divider" />
              <ul className="rdoc-list">
                {resumeData.achievements.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            {/* Seminars — compact card style */}
            <div className="rdoc-section">
              <h2 className="rdoc-section-title">Seminars & Trainings</h2>
              <div className="rdoc-divider" />
              {resumeData.seminars.map((sem, i) => (
                <div className="rdoc-seminar-entry" key={i}>
                  <div>
                    <p className="rdoc-seminar-title">{sem.title}</p>
                    <p className="rdoc-seminar-organizer">{sem.organizer}</p>
                  </div>
                  <span className="rdoc-seminar-date">{sem.date}</span>
                </div>
              ))}
            </div>

          </div>
          {/* end rdoc-right */}

        </div>
        {/* end resume-document */}
      </div>
    </div>
  );
}
